import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { hasClass } from '@opten/dom/has-class';
import { removeClass } from '@opten/dom/remove-class';
import { IFramePlayer } from './iframe';

const stringIFramePlayer = 'IFramePlayer';
@Component({ className: 'js-player' })
export class IFramePlayerComponent {
	private player: IFramePlayer;
	private iFrameElement: HTMLIFrameElement;

	constructor(private element: HTMLElement) {
		this.player = new IFramePlayer(this.element);
		this.iFrameElement = this.element.getElementsByTagName('iframe')[0];
		if (hasClass(this.element, 'autoplay')) {
			if (this.iFrameElement.src.indexOf('background') != -1) {
				this.play();
			} else {
				setTimeout(() => {
					this.play();
				}, 1000);
			}
		}
		this.element[stringIFramePlayer] = this;
	}

	static getInstance(element: HTMLElement) {
		if (!element) return;
		return element[stringIFramePlayer] as IFramePlayerComponent;
	}

	play() {		
		if (this.iFrameElement.src.indexOf('autoplay') === -1) {
			this.iFrameElement.src +=
				this.iFrameElement.src.indexOf('?') === -1
					? '?autoplay=1'
					: '&autoplay=1';
		} else {
			this.iFrameElement.src = this.iFrameElement.src.replace(
				'autoplay=0',
				'autoplay=1'
			);
		}
		setTimeout(() => {			
			addClass(this.element, 'is-playing');
		}, 1500);
	}

	pause() {
		if (this.iFrameElement.src.indexOf('autoplay') === -1) {
			this.iFrameElement.src +=
				this.iFrameElement.src.indexOf('?') === -1
					? '?autoplay=0'
					: '&autoplay=0';
		} else {
			this.iFrameElement.src = this.iFrameElement.src.replace(
				'autoplay=1',
				'autoplay=0'
			);
		}
		removeClass(this.element, 'is-playing');
	}
}
